import { useEffect } from 'react';

import { useNavigate } from '@tanstack/react-router';

const MAINTENANCE_REVIEW_ROUTES = [
    '/aircrafts',
    '/aircrafts/[id]',
    '/aircrafts/[id]/work-order-upload',
    '/aircrafts/[id]/work_orders/[workOrderId]',
    '/aircrafts/[id]/work_orders/',
    '/line_items/[id]',
];

interface Props {
    isMaintenanceReviewEnabled: boolean;
    isLoading: boolean;
    path: string;
}

export function useMaintenanceReviewGuard({
    isMaintenanceReviewEnabled,
    isLoading,
    path,
}: Props) {
    const navigate = useNavigate();

    useEffect(() => {
        // Don't redirect while still loading - wait for actual value
        if (isLoading) return;
        if (isMaintenanceReviewEnabled) return;
        const pathWithoutQuery = path.split('?')[0];

        const isMaintenanceReviewRoute = MAINTENANCE_REVIEW_ROUTES.some(
            (route) => {
                // Replace [id] with alphanumeric pattern to handle both numeric IDs and part numbers like 01N65920
                const pattern = route.replace(/\[\w+\]/g, '[\\w\\-]+');

                const regex = new RegExp(`^${pattern}$`);
                return regex.test(pathWithoutQuery);
            },
        );

        if (isMaintenanceReviewRoute) navigate({ to: '/' });
    }, [path, navigate, isMaintenanceReviewEnabled, isLoading]);
}
